// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:600px){.new-products .seasidetms_product_header a{font-size:12px;line-height:1.2}}.new-products .seasidetms_product_img .payParts:after{display:none}.new-products .seasidetms_product_info .price{flex-direction:column}.new-products .seasidetms_product_info .amount{margin-right:0}", ""]);
// Exports
module.exports = exports;
